<template>
  <OmtLayoutContainer
    bg="#F6F6F9"
    :minHeight="['initial', 'calc(100vh - 80px)']"
  >
    <OmtRow>
      <CFlex
        flexDirection="column"
        width="100%"
        justify="space-between"
        minHeight="calc(100vh - 140px)"
        mt="16px"
      >
        <CBox>
          <OmtTypography
            as="h1-large"
            color="var(--colors-light-primary-dark-blue)"
            mb="30px"
            lineHeight="28px"
          >
            Escolha o método para análise
          </OmtTypography>

          <OmtTypography
            as="p1"
            color="var(--colors-light-primary-gray1)"
            lineHeight="22px"
            mb="24px"
          >
            A qualidade da avaliação depende de boa luz, rosto visível e estabilidade durante a captura ou leitura.
          </OmtTypography>

          <CBox
            v-if="hasError"
            bg="#FEF0F0"
            border="1px solid #CD1111"
            borderRadius="8px"
            p="16px 20px"
            mt="20px"
          >
            <OmtTypography
              as="h2-bold"
              color="#9B0B0B"
            >
              <span
                v-if="displayErrorMessage"
                style="white-space: pre-line"
                >{{ displayErrorMessage }}</span
              >
              <span v-else>A imagem aparenta ter problemas,<br />tente novamente</span>
            </OmtTypography>
          </CBox>
        </CBox>

        <CBox mt="auto">
          <CBox
            bg="white"
            border="1px solid #DADADA"
            borderRadius="8px"
            p="24px 20px"
            mb="40px"
            cursor="pointer"
            @click="agreed = !agreed"
          >
            <CFlex alignItems="center">
              <OmtCheckbox
                :is-checked="agreed"
                @change="agreed = !agreed"
                @click.native.stop
              >
                <OmtTypography
                  as="h3-regular"
                  color="var(--colors-light-primary-dark-blue)"
                  pl="12px"
                  lineHeight="20px"
                >
                  Concordo com o uso da imagem para análise demartológica
                </OmtTypography>
              </OmtCheckbox>
            </CFlex>
          </CBox>

          <CBox width="100%">
            <input
              ref="fileInput"
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              style="display: none"
              @change="handleFileChange"
            />
            <OmtButton
              :variant="isMobile ? 'outline' : 'solid'"
              size="lg"
              width="100%"
              :mb="isMobile ? '16px' : '0'"
              borderRadius="95px"
              :is-disabled="!agreed"
              @click="handleUploadPhoto"
            >
              Enviar foto
            </OmtButton>

            <OmtButton
              v-if="isMobile"
              size="lg"
              width="100%"
              borderRadius="95px"
              :opacity="!agreed ? 0.5 : 1"
              :cursor="!agreed ? 'not-allowed' : 'pointer'"
              @click="handleTakePhoto"
            >
              Tirar foto
            </OmtButton>
          </CBox>
        </CBox>
      </CFlex>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { CFlex, CBox } from "@chakra-ui/vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Swal from "sweetalert2";
import { isMobile } from "@/utils/utils";

export default {
  name: "skiniver-consent",
  components: {
    CFlex,
    CBox
  },
  data() {
    return {
      agreed: false
    };
  },
  computed: {
    ...mapState("skiniver", ["hasImageError", "errorMessage"]),
    isMobile() {
      return isMobile();
    },
    hasError() {
      return Boolean(this.hasImageError);
    },
    displayErrorMessage() {
      return this.errorMessage || "A imagem aparenta ter problemas,\ntente novamente";
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
  },
  methods: {
    ...mapActions("skiniver", ["uploadFile"]),
    ...mapMutations("skiniver", {
      setImageUrl: "SET_IMAGE_URL",
      setUploadMethod: "SET_UPLOAD_METHOD",
      clearError: "CLEAR_ERROR"
    }),
    handleUploadPhoto() {
      if (!this.agreed) return;
      this.clearError();
      this.setUploadMethod("upload");
      this.$refs.fileInput.click();
    },
    async handleFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      this.clearError();
      this.setUploadMethod("upload");
      this.$root.$emit("show-loading");
      let resp = {};
      let hasUploadError = false;

      try {
        resp = await this.uploadFile({
          filename: file.name,
          blobFile: file
        });
      } catch (error) {
        console.error(error);
        hasUploadError = true;
      } finally {
        this.$root.$emit("hide-loading");
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      }

      const uploadedPic = (resp && resp.Data && resp.Data[0]) || (resp && resp.Data);
      const fileRemoteUrl = uploadedPic && (uploadedPic.fileRemoteUrl || uploadedPic.url);

      if (hasUploadError || !fileRemoteUrl || (uploadedPic && uploadedPic.message && uploadedPic.message !== "OK")) {
        await Swal.fire({
          title: "Erro",
          text: (uploadedPic && uploadedPic.message) || "Não foi possível enviar a imagem. Tente novamente.",
          confirmButtonText: "OK",
          icon: "error"
        });
        return;
      }

      this.clearError();
      this.setImageUrl(fileRemoteUrl);
      this.$router.push({
        name: "skiniver.resultado"
      });
    },
    handleTakePhoto() {
      if (!this.agreed) return;
      this.clearError();
      this.setUploadMethod("camera");
      this.$router.push({
        name: "skiniver.instrucoes",
        query: { method: "camera" }
      });
    }
  }
};
</script>
